module.exports = __webpack_public_path__ + "img/speak_the_truth.64e75d25.jpg";